require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-better-monitoring-impact-forests.json") })
        }
      }, "path---en-us-update-better-monitoring-impact-forests");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-better-monitoring-impact-forests!./.cache/json/en-us-update-better-monitoring-impact-forests.json
// module id = 619
// module chunks = 231608221292675